// libraries
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Avatar, Button, Table } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { green } from '@ant-design/colors';

// utils
import { txt } from '../../../../locales/i18n';

export function ImageListDesktop({ dataSource, loading, handleAccept }: any): JSX.Element {
	const history = useHistory();

	function handleOpen(event: React.MouseEvent<HTMLElement, MouseEvent>, userId: number): void {
		event.stopPropagation();
		history.push(`/users/${userId}#image`);
	}

	function renderImage(image: string | null): JSX.Element {
		return <Avatar size={72} icon={<UserOutlined />} src={image} />;
	}

	function renderActions(id: number, record: Record<string, any>): JSX.Element {
		return (
			<div className="action-container">
				<Button className="approved-button" type="primary" onClick={(event) => handleAccept(event, id)}>
					{txt('global.approve')}
				</Button>
				<Button type="primary" onClick={(event) => handleOpen(event, record.userId)}>
					{txt('global.open')}
				</Button>
			</div>
		);
	}

	return (
		<StyledTable
			sticky
			rowKey="id"
			loading={loading}
			dataSource={dataSource}
			pagination={{ position: [], pageSize: 200 }}
			onRow={(user: Record<string, any>) => ({
				onClick: () => history.push(`/users/${user.userId}`),
			})}
		>
			<Table.Column
				dataIndex="image"
				title={txt('global.image')}
				width="10rem"
				render={renderImage}
				align="center"
			/>
			<Table.Column
				dataIndex="previousImage"
				title={txt('global.previous image')}
				width="10rem"
				render={renderImage}
				align="center"
			/>
			<Table.Column
				dataIndex="imageId"
				title={txt('global.actions')}
				width="14rem"
				render={renderActions}
				align="center"
			/>
			<Table.Column dataIndex="username" title={txt('global.user')} />
			<Table.Column dataIndex="age" title={txt('global.age')} />
		</StyledTable>
	);
}

const StyledTable = styled(Table)`
	overflow: auto;

	.action-container {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0.4rem;

		button {
			min-width: 6rem;
		}

		.approved-button {
			background: ${green.primary};
			border-color: ${green.primary};
		}
	}
`;
